import { useState, useEffect, Fragment, useMemo } from 'react'
import { NavLink, useLocation, useNavigate } from 'react-router-dom'

import styles from './Navbar.module.scss'
import { sidebarData } from './sidebarData'

import { User } from 'routes/components/Navbar/components'
import { handleLogoutAllTabs } from 'utilities/auth'
import { sendWhatsapp } from 'routes/components/Navbar/utilities/whatsapp'
import { Icon } from 'components'
import { useTenant } from 'shared/hooks'

export const NavBar = () => {
  const { tenant } = useTenant()

  const location = useLocation()
  const navigate = useNavigate()
  const [navbarOpen, setNavbarOpen] = useState(false)

  const defaultSubItemSelected = useMemo(() => {
    const array = location.pathname.split('/')

    return array[1]
  }, [location])

  const [subItemOpen, setSubItemOpen] = useState<string | undefined>(
    defaultSubItemSelected,
  )

  useEffect(() => {
    setSubItemOpen(() => defaultSubItemSelected)
  }, [location, navbarOpen])

  const handleOpenSubItems = (title?: string) => {
    if (subItemOpen === title) {
      return setSubItemOpen('')
    }

    setSubItemOpen(title)
  }

  return (
    <nav
      onMouseEnter={() => {
        setNavbarOpen(true)
      }}
      onMouseLeave={() => {
        setNavbarOpen(false)
      }}
      className={[styles.container, navbarOpen && styles.opened].join(' ')}
    >
      <div>
        <div className={styles.logo}>
          <Icon
            height={32}
            width={250}
            url={
              navbarOpen
                ? tenant?.brand.images.horizontalLogo
                : tenant?.brand.images.logo
            }
            name={navbarOpen ? 'ubisafe-logo' : 'ubisafe-micro-logo'}
            onClick={() => navigate('/')}
          />
        </div>

        <div>
          <div className={styles.user}>
            <User />
          </div>

          <ul>
            {sidebarData.map((menu) => {
              const subItemsOpen = subItemOpen
                ? menu.path.includes(subItemOpen || '')
                : false

              const showSubItems = menu.subItems && navbarOpen

              return (
                <Fragment key={menu.path}>
                  <li
                    onClick={() => {
                      if (!menu.subItems) {
                        return navigate(menu.path)
                      }

                      handleOpenSubItems(menu.path)
                    }}
                    className={[
                      (menu.path === location.pathname || subItemsOpen) &&
                        styles.active,
                    ].join(' ')}
                  >
                    <div>
                      <div>
                        {menu.icon}
                        <span>{menu.title}</span>
                      </div>
                    </div>

                    <div
                      className={[
                        styles.subItems,
                        showSubItems && subItemsOpen && styles.opened,
                      ].join(' ')}
                    >
                      {menu.subItems?.map((subItem) => {
                        return (
                          <NavLink
                            to={subItem.path}
                            key={subItem.path}
                            aria-label={subItem.title}
                            className={({ isActive }) =>
                              isActive ? styles.active : ''
                            }
                          >
                            {subItem.title}
                          </NavLink>
                        )
                      })}
                    </div>
                  </li>
                </Fragment>
              )
            })}
          </ul>
        </div>
      </div>
      <ul>
        {!!tenant?.contact?.customerNumber && (
          <li>
            <div
              onClick={() =>
                sendWhatsapp(tenant?.contact?.customerNumber || '')
              }
            >
              <div>
                <Icon name="whatsapp" width={17} /> <span>Fale conosco</span>
              </div>
            </div>
          </li>
        )}

        <li>
          <div onClick={handleLogoutAllTabs}>
            <div>
              <Icon name="logout" width={17} /> <span>Sair da conta</span>
            </div>
          </div>
        </li>
      </ul>
    </nav>
  )
}

export default NavBar
